import { IdTooltipAnchor } from "../../features/tooltip/IdTooltipAnchor";
export var isTopAnchored = function (anchor) {
    return anchor === IdTooltipAnchor.Top ||
        anchor === IdTooltipAnchor.TopLeft ||
        anchor === IdTooltipAnchor.TopRight;
};
export var isBottomAnchored = function (anchor) {
    return anchor === IdTooltipAnchor.Bottom ||
        anchor === IdTooltipAnchor.BottomLeft ||
        anchor === IdTooltipAnchor.BottomRight;
};
export var isLeftAnchored = function (anchor) { return anchor === IdTooltipAnchor.Left; };
export var isRightAnchored = function (anchor) { return anchor === IdTooltipAnchor.Right; };
export var isLeftAligned = function (anchor) {
    return anchor === IdTooltipAnchor.BottomLeft || anchor === IdTooltipAnchor.TopLeft;
};
export var isRightAligned = function (anchor) {
    return anchor === IdTooltipAnchor.BottomRight || anchor === IdTooltipAnchor.TopRight;
};
export var calculatePosition = function (pad, anchor, origin, content) {
    var anchorTop = isTopAnchored(anchor);
    var anchorBottom = isBottomAnchored(anchor);
    var anchorRight = isRightAnchored(anchor);
    var anchorLeft = isLeftAnchored(anchor);
    // anchor is above or below
    var alignedLeft = isLeftAligned(anchor);
    var alignedRight = isRightAligned(anchor);
    // our eventual tooltip position
    var box = {
        left: origin.left,
        minWidth: content.width < 160 ? 160 : content.width,
        top: origin.top,
    };
    var tooltipTailDimension = 6;
    var vOffset = content.height + tooltipTailDimension + pad;
    var hOffset = box.minWidth + tooltipTailDimension + pad;
    if (anchorTop) {
        box.top += vOffset;
    }
    else if (anchorBottom) {
        box.top -= vOffset;
    }
    else if (anchorLeft) {
        box.left += origin.width + tooltipTailDimension + pad;
    }
    else if (anchorRight) {
        box.left -= hOffset;
    }
    if (!anchorLeft && !anchorRight) {
        // centered
        if (!alignedLeft && !alignedRight) {
            box.left -= box.minWidth / 2;
            box.left += origin.width / 2;
        }
        else if (alignedRight) {
            box.left -= box.minWidth;
            box.left += origin.width;
        }
    }
    return box;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/tooltip/calculatePosition.ts
// module id = 1131
// module chunks = 3